export default __webpack_public_path__ + "static/media/eloc-web.df35282f.PNG";